import { ActivityTimeline, type TimelineEntry } from '@zealot/ui/components/activity/activity-timeline';
import { NoteComposer } from '@zealot/ui/components/activity/note-composer';
import { Button } from '@zealot/ui/components/button';
import { Stack } from '@zealot/ui/components/stack';
import { Trash2 } from 'lucide-react';
import type { ComponentProps } from 'react';

type ActivityTimelineProps = ComponentProps<typeof ActivityTimeline>;

// gloss
type ActivityFeedProps = Omit<ActivityTimelineProps, 'renderEntryAction'> & {
  onAddNote?: (body: string) => void | Promise<unknown>;
  onDeleteEntry?: (entryId: string) => void;
  isSubmitting?: boolean;
  composerPlaceholder?: string;
  composerSubmitLabel?: string;
  deleteLabel?: string;
};

// gloss
export const ActivityFeed = ({
  onAddNote,
  onDeleteEntry,
  isSubmitting = false,
  composerPlaceholder,
  composerSubmitLabel,
  deleteLabel = 'Delete note',
  ...timelineProps
}: ActivityFeedProps) => (
  <Stack gap={4} data-slot="activity-feed">
    {onAddNote && (
      <NoteComposer
        onSubmit={onAddNote}
        isSubmitting={isSubmitting}
        placeholder={composerPlaceholder}
        submitLabel={composerSubmitLabel}
      />
    )}
    <ActivityTimeline
      {...timelineProps}
      renderEntryAction={
        onDeleteEntry
          ? (entry: TimelineEntry) =>
              entry.canDelete ? (
                <Button
                  variant="ghost"
                  size="icon-sm"
                  onClick={() => onDeleteEntry(entry.id)}
                  disabled={isSubmitting}
                  aria-label={entry.actorLabel ? `${deleteLabel} from ${entry.actorLabel}` : deleteLabel}
                  title={deleteLabel}
                >
                  <Trash2 className="text-muted-foreground" />
                </Button>
              ) : null
          : undefined
      }
    />
  </Stack>
);
